<template>
    <td-dialog :title="$t(title)" :before-close="dbDialogClose" :visible.sync="dialogDbVisible" width="380px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formDbInfo" ref="formDbInfo" :rules="rules" label-position="right" label-width="80px">
            <el-form-item :label="$t('pgCommon.NAME')" prop="caption">
                <td-input v-model="formDbInfo.caption" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DATABASE_TYPE')" prop="dbType">
                <td-select v-model="formDbInfo.dbType" :placeholder="$t('pgCommon.PLEASE_SELECT')" :options="dbTypeList" keys="S_CODE" text="S_VALUE" @change="changeSelect"> </td-select>
            </el-form-item>
            <el-form-item :label="dbNameLabel" prop="dbName">
                <td-input v-model="formDbInfo.dbName" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DATABASE_IP')" prop="ip">
                <td-input v-model="formDbInfo.ip"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DATABASE_PORT')" prop="port">
                <td-input-number v-model="formDbInfo.port" min="1" max="65535"></td-input-number>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DATABASE_USERNAME')" prop="username">
                <td-input v-model="formDbInfo.username" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('pgCommon.DATABASE_PWD')" prop="password">
                <td-input v-model="formDbInfo.password" type="password" maxlength="50"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button @click="connectDb('formDbInfo')" :loading="connectLoading">{{ $t('pgCommon.DATABASE_CONN_TEST') }}</td-button>
            <td-button type="primary" :loading="addLoading" @click="submitForm('formDbInfo')">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="dbDialogClose">{{ $t('pgCommon.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import resourceApi from './../assets/api.js';
export default {
    props: ['title', 'dialogDbVisible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        this.initSelectData();
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        let validateIpName = (rule, value, callback) => {
            let id = '';
            if (!this.isAddData) {
                id = this.editItem.id;
            }
            let param = {
                id: id,
                dbType: this.formDbInfo.dbType,
                ip: this.formDbInfo.ip,
                dbName: this.formDbInfo.dbName
            };
            resourceApi.checkIpNameRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('dbApi.checkIpNameRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgCommon.IP_DBNAME_HAS_EXIST_PLEASE_INPUT'));
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            // db表单信息
            formDbInfo: {
                dbType: '',
                caption: '',
                dbName: '',
                ip: '',
                port: '',
                username: '',
                password: ''
            },
            dbNameLabel: this.$t('pgCommon.DBNAME_MYSQL'),
            dbTypeList: [],
            noCustomMenuUrl: true,
            customMenuUrlFlg: false,
            noCustomDeptUrl: true,
            customDeptUrlFlg: false,
            connectLoading: false, // 按钮是否为加载状态
            addLoading: false,
            // 对表单进行数据验证
            rules: {
                dbType: [{ required: true, message: this.$t('pgError.ERROR_DBTYPE_NULL') }],
                dbName: [
                    { required: true, message: this.$t('pgError.ERROR_DBNAME_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('pgError.ERROR_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') },
                    { validator: validateIpName, trigger: 'blur' }
                ],
                caption: [
                    { required: true, message: this.$t('pgError.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('pgError.ERROR_MAX_LENGTH'), trigger: 'blur' },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                ip: [
                    { required: true, message: this.$t('pgError.ERROR_IP_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.IP_RULE, message: this.$t('error.ERROR_IP_FORMAT') },
                    { validator: validateIpName, trigger: 'blur' }
                ],
                port: [{ required: true, message: this.$t('pgError.ERROR_PORT_NULL') }],
                username: [{ required: true, message: this.$t('pgError.ERROR_USERNAME_NULL'), trigger: 'blur' }],
                password: [{ required: true, message: this.$t('pgError.ERROR_PWD_NULL'), trigger: 'blur' }, { min: 1, max: 50, message: this.$t('pgError.ERROR_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化数据库下拉列表数据
        initSelectData() {
            resourceApi.listAllDbTypes({}, response => {
                if (response.status === undefined) {
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/tableDbController/listAllDbTypes', response.data.statusMessage);
                    return;
                }
                this.dbTypeList = response.data.content;
                if (!this.isAddData) {
                    this.initEditData();
                }
            });
        },
        // 初始化编辑数据
        initEditData() {
            this.formDbInfo.dbType = this.editItem.dbType;
            if (this.editItem.dbType == 0) {
                this.dbNameLabel = this.$t('pgCommon.DBNAME_MYSQL');
            } else if (this.editItem.dbType == 1) {
                this.dbNameLabel = this.$t('pgCommon.DBNAME_ORACLE');
            }
            this.formDbInfo.caption = this.editItem.caption;
            this.formDbInfo.dbName = this.editItem.dbName;
            this.formDbInfo.ip = this.editItem.ip;
            this.formDbInfo.port = this.editItem.port;
            this.formDbInfo.username = this.editItem.username;
            this.formDbInfo.password = this.editItem.password;
            this.dbFlgReadonly = true;
        },
        // 连接数据库测试
        connectDb(formName, isAuthSave) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (!isAuthSave) {
                        this.connectLoading = true;
                    }
                    var content = {
                        dbType: this.formDbInfo.dbType,
                        caption: this.formDbInfo.caption,
                        dbName: this.formDbInfo.dbName,
                        ip: this.formDbInfo.ip,
                        port: this.formDbInfo.port,
                        username: this.formDbInfo.username,
                        password: this.formDbInfo.password
                    };
                    resourceApi.connectDbTest(JSON.stringify(content), response => {
                        this.connectLoading = false;
                        this.addLoading = false;
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            this.$log.error('dialogDbinfo/connectDbTest', response);
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('dialogDbinfo/connectDbTest', response.data.statusMessage);
                            return;
                        }
                        if (isAuthSave) {
                            this.saveData(content);
                        } else {
                            this.$message({ showClose: true, message: this.$t('pgCommon.DATABASE_CONN_SUCC'), type: 'success' });
                        }
                    });
                }
            });
        },
        changeSelect(param) {
            // 根据数据库类型，动态改变label值
            if (param == 0) {
                //MYSQL数据库
                this.dbNameLabel = this.$t('pgCommon.DBNAME_MYSQL');
                this.formDbInfo.port = this.$t('pgCommon.MYSQL_DEFAULT_PORT');
            } else if (param == 1) {
                //ORACLE数据库
                this.dbNameLabel = this.$t('pgCommon.DBNAME_ORACLE');
                this.formDbInfo.port = this.$t('pgCommon.ORACLE_DEFAULT_PORT');
            } else {
                //其他
                this.dbNameLabel = this.$t('pgCommon.DBNAME_MYSQL');
                this.formDbInfo.port = undefined;
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.addLoading = true;
                    this.connectDb(formName, true);
                }
            });
        },

        saveData(content) {
            if (this.isAddData) {
                resourceApi.insertDbInfo(JSON.stringify(content), response => {
                    this.addLoading = false;
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('dialogDbinfo/insertDbInfo', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                    this.dbDialogClose();
                    /* 编辑或添加完成需调用查询接口 */
                    this.$emit('btnQuery');
                });
            } else {
                content.id = this.editItem.id;
                resourceApi.updateDbInfo(JSON.stringify(content), response => {
                    this.addLoading = false;
                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('dialogDbinfo/updateDbInfo', response.data.statusMessage);
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('pgCommon.MODIFY_SUCCESS'), type: 'success' });
                    this.dbDialogClose();
                    /* 编辑或添加完成需调用查询接口 */
                    this.$emit('btnQuery');
                });
            }
        },

        // 关闭窗口之前需要调用的方法
        dbDialogClose() {
            this.$emit('dbDialogClose');
            this.$refs['formDbInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
